import {
  TOGGLE_LAYOUT_EDIT_UI,
  SET_LAYOUT_EDIT_UI,
  SET_LAYOUT_EDIT_UI_ACTIVE,
  UPDATE_ELEMENT_SEARCH,
  SET_TARGET_DROP_ZONE,
  SET_EDITOR_VIEW_MODE,
} from '@constants/mutations'

export const state = {
  isShowingLayoutEditUI: false,
  isLayoutEditUIActive: false,
  elementSearch: null,
  targetDropZoneId: null,
  editorViewMode: 'fit-view',
}

export const mutations = {
  [TOGGLE_LAYOUT_EDIT_UI](state) {
    state.isShowingLayoutEditUI = !state.isShowingLayoutEditUI
    if (state.isShowingLayoutEditUI) {
      state.isLayoutEditUIActive = true
    }
  }, // TOGGLE_LAYOUT_EDIT_UI
  [SET_LAYOUT_EDIT_UI](state, visibility) {
    state.isShowingLayoutEditUI = visibility
    if (visibility) {
      state.isLayoutEditUIActive = true
    }
  }, // SET_LAYOUT_EDIT_UI
  [SET_LAYOUT_EDIT_UI_ACTIVE](state, val) {
    state.isLayoutEditUIActive = val
  }, // SET_LAYOUT_EDIT_UI_ACTIVE
  [UPDATE_ELEMENT_SEARCH](state, q) {
    state.elementSearch = q
  }, // UPDATE_ELEMENT_SEARCH
  [SET_TARGET_DROP_ZONE](state, regionId) {
    state.targetDropZoneId = regionId
  }, // SET_TARGET_DROP_ZONE
  [SET_EDITOR_VIEW_MODE](state, mode) {
    state.editorViewMode = mode
  }, // SET_EDITOR_VIEW_MODE
}

export const getters = {
  isShowingLayoutEditUI: (state) => state.isShowingLayoutEditUI,
  isLayoutEditUIActive: (state) => state.isLayoutEditUIActive,
  elementSearch: (state) => state.elementSearch,
  targetDropZoneId: (state) => state.targetDropZoneId,
  editorViewMode: (state) => state.editorViewMode,
  isInMenuEditMode: (state, _, rootState) => rootState.editor.isShowingEditUI,
}

export const actions = {
  toggleLayoutEditUI({ commit, state, rootGetters, dispatch }) {
    if (!state.isShowingLayoutEditUI && !rootGetters['auth/loggedIn']) {
      dispatch('auth/showAuthModal', null, { root: true })
      return
    }
    if (state.isShowingLayoutEditUI && state.editorViewMode === 'fit-width') {
      commit(SET_EDITOR_VIEW_MODE, 'fit-view')
    }
    commit(TOGGLE_LAYOUT_EDIT_UI)
  }, // toggleLayoutEditUI
  setLayoutEditUI({ commit, state }, visibility) {
    if (!visibility && state.editorViewMode === 'fit-width') {
      commit(SET_EDITOR_VIEW_MODE, 'fit-view')
    }
    commit(SET_LAYOUT_EDIT_UI, visibility)
  }, // setLayoutEditUI
  setLayoutEditUIActive({ commit }, val) {
    commit(SET_LAYOUT_EDIT_UI_ACTIVE, val)
  }, // setLayoutEditUIActive
  updateElementSearch({ commit }, query) {
    commit(UPDATE_ELEMENT_SEARCH, query)
  }, // updateElementSearch
  setTargetDropZone({ commit }, regionId) {
    commit(SET_TARGET_DROP_ZONE, regionId)
  }, // setTargetDropZone
  setEditorViewMode({ commit }, mode) {
    commit(SET_EDITOR_VIEW_MODE, mode)
  }, // setEditorViewMode
} // actions
